<template>
  <div>
    <div v-if="uploadPercentage !== null && uploadPercentage <100">
      <v-progress-linear
        :value="uploadPercentage"
        height="30"
        color="light-blue"
        striped
      >
        <template v-slot:default="{ value }">
          <strong>{{ value }}%</strong>
        </template>
      </v-progress-linear>
    </div>
    <v-file-input
      :label="dataField.title ? dataField.title : ''"
      :multiple="dataField.params.multiple ? dataField.params.multiple : true"
      :placeholder="
        dataField.placeholder ? dataField.placeholder : 'انتخاب فایل'
      "
      :disabled="isLoading"
      :loading="isLoading"
      :accept="dataField.class ? dataField.class : ''"
      chips
      show-size
      @change="upload"
      :background-color="
        alerts[dataField.name] ? 'red lighten-4' : 'grey lighten-5'
      "
      :rules="dataField.params.required ? required : null"
      :error="alerts[dataField.name] != null"
      :error-messages="alerts[dataField.name]"
    >
    </v-file-input>

    <v-col cols="12">
      <v-row
        style="
          background-color: #fafafa;
          padding: 5px;
          border: 1px dashed #ccc;
          border-radius: 3px;
          margin: 2px 0px;
        "
        v-show="Object.keys(previewList).length != 0"
      >
        <v-col
          v-for="(item, index) in previewList"
          :key="index"
          cols="4"
          sm="3"
        >
          <a target="_bank" :href="item.file_link">
            <video v-if="item.file_type == 'video/mp4'" width="250px" controls>
              <source :src="item.file_prev" type="video/mp4" />

              Your browser does not support the video tag.
            </video>
            <v-img
              v-else
              style="border: 1px solid #ccc; border-radius: 3px"
              height="40"
              :src="item.file_prev"
            ></v-img>
          </a>
        </v-col>
      </v-row>
    </v-col>
    <v-snackbar v-model="isToast" color="toastType">
      {{ toast }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "FileInput",
  props: ["dataField", "fieldName"],
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPostFile", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    submitLoading: {
      get() {
        return this.$store.state.submitLoading;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
  mounted() {},
  data() {
    return {
      isToast: false,
      toast: "",
      isLoading: false,
      toastType: null,
      previewList: [],
      uploadPercentage: null,
      required: [(v) => !!v || "اجباری می باشد"],
    };
  },
  methods: {
    async upload(file) {
      this.alerts[this.dataField.name] = null;
      this.setLoading(true);
      let formData = new FormData();
      for (var i = 0; i < file.length; i++) {
        formData.append("files[" + i + "]", file[i]);
      }
       try {
      await this.axios
        .post(this.$store.state.urlUpload, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            withCredentials: true,
          },
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          },
        })
        .then((Response) => {
          this.setLoading(false);
          let data = Response.data;
          if (data.code == -1) alert(data.explanation);
          this.previewList = data.data.documents;

          this.previewList.map((Item) => {
            let tmp = [];
            let name = this.fieldName
              ? this.fieldName.name
              : this.dataField.name;
            if (this.dataPost[name] !== undefined) tmp = this.dataPost[name];

            tmp.push(Item.id);
            this.dataPost[name] = tmp;
            this.$store.commit("updateReviewFieldByIndex", {
              index: name,
              val: Item.file_prev,
            });
            this.showToast('success', data.message.error)
          });
        })
        .catch((error) => {
          this.uploadPercentage = null;
          this.showToast("error", "خطا در بارگزاری فایل");
          console.log(222,error);
          this.alerts[this.dataField.name] = "خطا در بارگزاری فایل حداکثر حجم فایل ۵۰ مگابایت";
        });
         } catch (error) {
          console.log('err upload',error)
       
      }
      this.setLoading(false);
    },
    setLoading(status) {
      this.isLoading = status;
      // this.$store.commit("updateSubmitLoading", status);
    },
    showToast(type, message) {
      this.isToast = true;
      this.toastType = type;
      this.toast = message;
    },
    
  },
};
</script>
